import { FloatingContext, useTransitionStyles } from "@floating-ui/react";
import dimensionTokens from "../tokens/dimension.value.tokens.json";
const ANIMATION_DURATION = parseInt(
  dimensionTokens.transition.duration.base.$value
);
const ANIMATION_SCALE = parseFloat(
  dimensionTokens.transition.scale.base.$value
);

export const useFloatingTransition = (context: FloatingContext) => {
  // Check for reduced motion preference
  const prefersReducedMotion =
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
      : false;

  const { isMounted, styles: transitionStyles } = useTransitionStyles(context, {
    duration: prefersReducedMotion ? 0 : ANIMATION_DURATION,
    initial: {
      opacity: 0,
      scale: prefersReducedMotion ? 1 : ANIMATION_SCALE,
    },
    open: {
      opacity: 1,
      scale: 1,
    },
    close: {
      opacity: 0,
      scale: prefersReducedMotion ? 1 : ANIMATION_SCALE,
    },
  });

  return { isMounted, transitionStyles };
};
